<template>
  <v-container class="py-8">
    <v-card>
      <v-card-title
        >Livelihood Questionnaire

        <strong
          :style="{
            color: totalCompletion === 100 ? 'green' : 'orange',
            'font-size': '18px',
          }"
        >
          ( {{ totalCompletion }}% )
        </strong>
      </v-card-title>
      <v-divider></v-divider>

      <!-- Stepper Navigation -->
      <v-stepper v-model="step">
        <v-stepper-header>
          <v-stepper-item :step="1" :complete="step > 1" editable>
            <div class="d-flex align-center justify-space-between w-100">
              <span>1 - Beneficiary Details</span>

              <span
                :style="{
                  'margin-left': '5px',
                  color: stepCompletion[1] === 100 ? 'green' : 'orange',
                  'font-weight': 'bold',
                }"
              >
                (
                {{ stepCompletion[1] }}% )
              </span>
            </div>
          </v-stepper-item>

          <v-divider></v-divider>
          <v-stepper-item :step="2" :complete="step > 2" editable>
            <div class="d-flex align-center justify-space-between w-100">
              <span>2 - Job Details</span>

              <span
                :style="{
                  'margin-left': '5px',
                  color: stepCompletion[2] === 100 ? 'green' : 'orange',
                  'font-weight': 'bold',
                }"
              >
                (
                {{ stepCompletion[2] }}% )
              </span>
            </div>
          </v-stepper-item>
          <v-divider></v-divider>
          <v-stepper-item :step="3" :complete="step > 3" editable>
            <div class="d-flex align-center justify-space-between w-100">
              <span>3 - Satisfaction</span>

              <span
                :style="{
                  'margin-left': '5px',
                  color: stepCompletion[3] === 100 ? 'green' : 'orange',
                  'font-weight': 'bold',
                }"
              >
                (
                {{ stepCompletion[3] }}% )
              </span>
            </div>
          </v-stepper-item>
          <v-divider></v-divider>
          <v-stepper-item :step="4" editable>
            <div class="d-flex align-center justify-space-between w-100">
              <span>4 - Odyssea Journey</span>

              <span
                :style="{
                  'margin-left': '5px',
                  color: stepCompletion[4] === 100 ? 'green' : 'orange',
                  'font-weight': 'bold',
                }"
              >
                (
                {{ stepCompletion[4] }}% )
              </span>
            </div>
          </v-stepper-item>
          <v-divider></v-divider>
          <v-stepper-item :step="5" editable>5 - Preview </v-stepper-item>
        </v-stepper-header>

        <!-- Stepper Content -->
        <v-stepper-window>
          <!-- Step 1 -->
          <v-stepper-window-item :step="1" eager>
            <v-form v-model="validStep1">
              <v-card-text>
                <Step1Form
                  v-model:form="form.form1"
                  :rules="rules"
                  @update:completion="stepCompletion[1] = $event"
                />
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="employability"
                  variant="outlined"
                  @click="nextStep(1)"
                  >Next</v-btn
                >
              </v-card-actions>
            </v-form>
          </v-stepper-window-item>

          <!-- Step 2 -->
          <v-stepper-window-item :step="2" eager>
            <v-form v-model="validStep2">
              <v-card-text>
                <Step2Form
                  v-model:form="form.form2"
                  :rules="rules"
                  @update:completion="stepCompletion[2] = $event"
                />
              </v-card-text>
              <v-card-actions>
                <v-btn variant="outlined" @click="prevStep">Back</v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  color="employability"
                  variant="outlined"
                  @click="nextStep(2)"
                  >Next</v-btn
                >
              </v-card-actions>
            </v-form>
          </v-stepper-window-item>

          <!-- Step 3 -->
          <v-stepper-window-item :step="3" eager>
            <v-form v-model="validStep3">
              <v-card-text>
                <Step3Form
                  v-model:form="form.form3"
                  :rules="rules"
                  @update:completion="stepCompletion[3] = $event"
                />
              </v-card-text>
              <v-card-actions>
                <v-btn variant="outlined" @click="prevStep">Back</v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  color="employability"
                  variant="outlined"
                  @click="nextStep(3)"
                  >Next</v-btn
                >
              </v-card-actions>
            </v-form>
          </v-stepper-window-item>

          <!-- Step 4 -->
          <v-stepper-window-item :step="4" eager>
            <v-form v-model="validStep4">
              <v-card-text>
                <Step4Form
                  v-model:form="form.form4"
                  :rules="rules"
                  @update:completion="stepCompletion[4] = $event"
                />
              </v-card-text>
              <v-card-actions>
                <v-btn variant="outlined" @click="prevStep">Back</v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  color="employability"
                  variant="outlined"
                  @click="nextStep(4)"
                  >Next</v-btn
                >
              </v-card-actions>
            </v-form>
          </v-stepper-window-item>

          <!-- Step 5 -->
          <v-stepper-window-item :step="5" eager>
            <Step5Form :form="form" />
            <v-card-actions>
              <v-btn variant="outlined" @click="prevStep">Back</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="success" variant="outlined" @click="submitForm"
                >Confirm</v-btn
              >
            </v-card-actions>
          </v-stepper-window-item>
        </v-stepper-window>
      </v-stepper>
    </v-card>
    <v-snackbar
      v-model="showIncompleteMessage"
      color="red"
      timeout="3000"
      elevation="3"
    >
      Please complete all steps before submitting the form (100% required).
    </v-snackbar>
  </v-container>
</template>

<script setup>
import { ref, reactive, watch, onMounted, computed } from "vue";
import Step1Form from "@/components/livelihood/forms/elements/wizard/Step1Form.vue";
import Step2Form from "@/components/livelihood/forms/elements/wizard/Step2Form.vue";
import Step3Form from "@/components/livelihood/forms/elements/wizard/Step3Form.vue";
import Step4Form from "@/components/livelihood/forms/elements/wizard/Step4Form.vue";
import Step5Form from "@/components/livelihood/forms/elements/wizard/Step5Form.vue";
import { useLivelihoodQuestionnaireStore } from "@/stores";
import { useGlobalStore } from "@/stores/global";

const store = useLivelihoodQuestionnaireStore();

// Stepper
const step = ref(0);

const showIncompleteMessage = ref(false);
// Form validation
const validStep1 = ref(false);
const validStep2 = ref(false);
const validStep3 = ref(false);
const validStep4 = ref(false);

// Step forms as reactive objects
const form1 = reactive({
  beneficiaryIntake: null,
  currentlyWorking: null,
  didOdysseaSupport: null,
});
const form2 = reactive({
  netSalaryRange: [380, 1500],
  /* Step 2 fields */
});
const form3 = reactive({
  /* Step 3 fields */
});
const form4 = reactive({
  /* Step 4 fields */
});

const stepCompletion = reactive({
  1: 0,
  2: 0,
  3: 0,
  4: 0,
});

// Main form combining all steps
const form = reactive({
  form1,
  form2,
  form3,
  form4,
});

// Simple validation rules
const rules = {
  required: (v) => !!v || "This field is required",
};

// Navigation
const nextStep = async (currentStep) => {
  const formMap = { 1: form1, 2: form2, 3: form3, 4: form4 };
  const currentForm = formMap[currentStep];
  // Only validate if form has validate method (if using v-form refs)
  if (currentForm?.validate) {
    const isValid = await currentForm.validate();
    if (isValid) step.value++;
  } else {
    step.value++;
  }
};

const prevStep = () => {
  if (step.value > 1) step.value--;
};

const totalCompletion = computed(() => {
  const steps = [1, 2, 3, 4];
  const sum = steps.reduce((acc, n) => acc + stepCompletion[n], 0);
  return Math.round(sum / steps.length);
});

const submitForm = async () => {
  if (totalCompletion.value < 100) {
    showIncompleteMessage.value = true;

    setTimeout(() => {
      showIncompleteMessage.value = false;
    }, 3000);

    return;
  }
  try {
    await store.createLivelihood(form);
  } catch (error) {
    console.error("Error submitting form:", error);

    const globalStore = useGlobalStore();
    globalStore.showSnackbar({
      show: true,
      text: "❌ Failed to submit the form. Please try again.",
      timeout: 5000,
      type: "error",
      position: "top",
    });
  }
};
</script>
